import React from 'react';
import EmptyBack from 'assets/images/noImage/background store 4.svg';
import {timeFromCreated} from 'utilities/helper/timeFromCreated';

interface ReplyChatProps {
  title: string;
  created: string;
  img: string | null;
}
const ReplyChat = ({title, img, created}: ReplyChatProps) => {
  return (
    <div className=" py-2 flex flex-col bg-white rounded-lg shadow-[0_4px_5px_rgba(171,190,209,0.3)] ">
      <div className="flex  w-full gap-4 px-2 ">
        <div className="flex w-[120px] h-[103px] relative">
          <img
            className="rounded-md"
            src={img ? img : EmptyBack}
            width={120}
            height={103}
            alt={title}
          />
          <span className="absolute text-chat-author rounded-2xl p-1 bg-white text-[8px] font-medium leading-[18px] top-1 right-1 ">
            {timeFromCreated(created)}
          </span>
        </div>
        <div className="flex flex-col items-start w-[70%] justify-between gap-4 ">
          <p className="text-end w-full flex justify-start text-black text-[14px] font-medium leading-[18px] not-italic	text-ellipsis max-w-[120px]">
            {title}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReplyChat;
